import { makeStyles } from '@material-ui/core';

export const useTableStyles = makeStyles((theme) => ({
  tableHeader: {
    display: 'grid',
    alignItems: 'center',
    margin: '0 0 8px',
    color: '#949494',
    '& *': {
      fontFamily: `'Open Sauce One', sans-serif`,
      fontSize: '13px',
      lineHeight: '20px',
      color: '#949494',
    },
  },

  tableRow: {
    width: '100%',
    display: 'grid',
    padding: '18px 0',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '20px',
    borderBottom: '1px solid #FFFFFF1A',
  },
  clickable: {
    cursor: 'pointer',
  },

  assetsCells: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },

    '& > h3': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      [theme.breakpoints.down('md')]: {
        fontWeight: 400,
        lineHeight: '20px',
      },
    },

    '& > p': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      color: '#949494',
      [theme.breakpoints.down('md')]: {
        fontWeight: 400,
        lineHeight: '20px',
      },
    },
  },
}));
